import React, { useState } from "react";
import { RootStateOrAny, useDispatch, useSelector } from "react-redux";
import { handleBottomDrawer } from "../../actions/actionCreators";
import { getProductId } from "../../actions/folders-actions/actions";
import { useParams, Link, useLocation } from "react-router-dom";
import { Button } from "../Button/Button";
import color_circle from "../../img/color-circle.svg";
import { nextProd, prevProd } from "../../actions/products-actions/actions";
import backward from "../../img/backward.png";
import placeholder from "../../img/img_placeholder.svg";
import forward from "../../img/forward.png";
import { Button as AntButton, Modal, Input, message, Tooltip, Divider, Space, Spin } from "antd";
import { PlusOutlined, FolderAddOutlined, LoadingOutlined } from "@ant-design/icons";
import { getAllUserFolders, createUserFolder, attachProductToFolder } from "../../actions/user-folders-actions/actions";
import PlusIcon from "../../icons/PlusIcon";
import { MyNotif } from "../NotifIcons/NotifIcons";

const ProductFooter = ({ oneProduct, width, isLoadingNext }: any) => {
  const dispatch = useDispatch();
  const params: any = useParams();
  const location: any = useLocation();

  const { nextProduct, prevProduct } = useSelector(
    (state: RootStateOrAny) => state.products
  );
  const { user, isAdmin } = useSelector((state: any) => state.auth);
  const { folders: adminFolders, isLoading: isAdminFoldersLoading } = useSelector((state: RootStateOrAny) => state.userFolders || { folders: [], isLoading: false });

  const [isAdminModalVisible, setIsAdminModalVisible] = useState(false);
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [newFolderName, setNewFolderName] = useState("");
  const [selectedFolderId, setSelectedFolderId] = useState<any>(null);
  const [isTryOnModalOpen, setIsTryOnModalOpen] = useState(false);
  const [tryOnUrl, setTryOnUrl] = useState("");


  return isLoadingNext ? (
    <p>loading...</p>
  ) : (
    <div
      className={
        user && !isAdmin
          ? "product_fontinnalities_container d-flex"
          : " product_fontinnalities_container d-flex"
      }
      style={{ minHeight: "90px", alignItems: "stretch" }}
    >
      {user && (
        <div
          style={{ flex: 1, width: "100%" }}
          className="d-flex align-items-stretch"
        >
          <AntButton
            onClick={() => {
              if (isAdmin) {
                 setIsAdminModalVisible(true);
                dispatch(getAllUserFolders()); 
           /*      MyNotif("Coming soon", "error"); */
              } else {
                dispatch(handleBottomDrawer());
                dispatch(getProductId(params.productId));
              }
            }}
            className="add-collection-footer"
          >
            Add to  {isAdmin ? "folder" : "collection"}
          </AntButton>
            
          <Modal
            title={<div style={{ fontSize: '18px', fontWeight: 600 }}>Collections</div>}
            visible={isAdminModalVisible}
            onCancel={() => {
              setIsAdminModalVisible(false);
              setShowCreateForm(false);
            }}
            footer={null}
            width={500}
            centered
            className="admin_collection_modal"
          >
            {showCreateForm ? (
               <div className="create_folder_form_admin" style={{ padding: '10px 0' }}>
                  <h4 style={{ marginBottom: '16px' }}>Create New Collection</h4>
                  <div style={{ marginBottom: '20px' }}>
                    <label style={{ display: 'block', marginBottom: '8px', fontSize: '13px', color: '#64748b' }}>Collection Name</label>
                    <Input 
                      placeholder="e.g. Summer Special 2026" 
                      value={newFolderName}
                      onChange={(e) => setNewFolderName(e.target.value)}
                      size="large"
                    />
                  </div>
                  <Space style={{ width: '100%', justifyContent: 'flex-end' }}>
                    <AntButton onClick={() => setShowCreateForm(false)}>Cancel</AntButton>
                    <AntButton 
                      type="primary" 
                      onClick={() => {
                        if (!newFolderName) {
                           message.error("Please enter a collection name");
                           return;
                        }
                        dispatch(createUserFolder({ name: newFolderName }));
                        setNewFolderName("");
                        setShowCreateForm(false);
                      }}
                    >
                      Create
                    </AntButton>
                  </Space>
               </div>
            ) : (
              <div className="admin_collections_list_wrapper">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                  <span style={{ color: '#64748b', fontSize: '13px' }}>Choose a collection</span>
                  <AntButton 
                    type="text" 
                    icon={<PlusOutlined />} 
                    onClick={() => setShowCreateForm(true)}
                    style={{ color: '#00468c', fontWeight: 500 }}
                  >
                    New
                  </AntButton>
                </div>
                
                <div className="admin_folders_scroll" style={{ maxHeight: '400px', overflowY: 'auto', marginBottom: '20px', padding: '4px' }}>
                  {isAdminFoldersLoading && adminFolders.length === 0 ? (
                    <div style={{ padding: '40px', textAlign: 'center' }}>
                      <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
                    </div>
                  ) : adminFolders && adminFolders.length > 0 ? (
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
                      {adminFolders.map((folder: any) => (
                        <div 
                          key={folder.id}
                          onClick={() => setSelectedFolderId(folder.id)}
                          style={{
                            padding: '12px 16px',
                            borderRadius: '10px',
                            border: `1.5px solid ${selectedFolderId === folder.id ? '#00468c' : '#f1f5f9'}`,
                            background: selectedFolderId === folder.id ? '#f0f7ff' : '#f8fafc',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            transition: 'all 0.2s'
                          }}
                        >
                          <FolderAddOutlined style={{ marginRight: '12px', fontSize: '20px', color: selectedFolderId === folder.id ? '#00468c' : '#64748b' }} />
                          <div style={{ flex: 1 }}>
                            <div style={{ fontWeight: 600, color: '#1e293b', fontSize: '14px' }}>{folder.name}</div>
                            <div style={{ fontSize: '12px', color: '#64748b' }}>{folder.products?.length || 0} Products</div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div style={{ padding: '40px', textAlign: 'center', color: '#64748b' }}>
                      No collections found. Create your first one!
                    </div>
                  )}
                </div>

                <div style={{ borderTop: '1px solid #f1f5f9', paddingTop: '16px' }}>
                  <AntButton 
                    type="primary" 
                    block 
                    size="large"
                    disabled={!selectedFolderId}
                    onClick={() => {
                        dispatch(attachProductToFolder(selectedFolderId, params.productId));
                        setIsAdminModalVisible(false);
                    }}
                    style={{ height: '48px', borderRadius: '8px', fontWeight: 600 }}
                  >
                    Confirm Attachment
                  </AntButton>
                </div>
              </div>
            )}
          </Modal>

          {!isAdmin && (
            <>
              <Link
                to={`/customization/new/${oneProduct && oneProduct.id}`}
                className="  customization_link"
              >
                <AntButton
                  style={{ height: "100%", width: "100%", }}
                  className="d-flex align-items-center justify-content-center"
                >
                  <img src={color_circle} className="mr-2" />
                  Start customization
                </AntButton>
              </Link>
            {/*    <Link
                to="#"
                className="  customization_link"
              >
              <AntButton
                 style={{ height: "100%", width: "100%", }}
                className="d-flex align-items-center justify-content-center"
                onClick={() => {
                  const frontImg = oneProduct?.images?.[0]?.path || oneProduct?.images?.[0] || "";
                  const garmentUrl = process.env.REACT_APP_STORAGE_URL + frontImg;
                  setTryOnUrl(`https://tryonidwebshop.pythonanywhere.com/?garment_url=${garmentUrl}`);
                  setIsTryOnModalOpen(true);
                }}
              >
                AI Preview
              </AntButton>
              </Link> */}
            </>
          )}

         <Modal
            title="AI Preview"
            visible={isTryOnModalOpen}
            onCancel={() => setIsTryOnModalOpen(false)}
            footer={null}
            width="95%"
            style={{ top: 20 }}
            bodyStyle={{ height: '85vh', padding: 0 }}
            destroyOnClose
          >
            <iframe 
              src={tryOnUrl} 
              width="100%" 
              height="100%" 
              style={{ border: 'none', borderRadius: '8px' }}
              title="AI Preview"
            />
          </Modal>

        </div>
      )}
  {/*    <div
        className="btns-group-product d-flex align-items-center"
        style={{ borderRight: "1px solid #C0C8D0" }}
      >
      {!location.pathname.includes("new") &&
          !location.pathname.includes("MySelection") && (
            <>
              <Link
                to={
                  prevProduct
                    ? location.pathname.includes("search")
                      ? `/search/result/${params.keyword}/${prevProduct.name}/${prevProduct.id}`
                      : `/product/details/${params.category}/${params.gendre}/${params.style}/${prevProduct.name}/${prevProduct.id}`
                    : "#"
                }
                onClick={() => prevProduct && dispatch(prevProd(prevProduct))}
              >
                <div className="arrow_contanier arrow_contanier_left">
                  <img src={backward} alt="" className="arrow_prev" />
                  {prevProduct ? (
                    <img
                      src={
                        prevProduct.images.length
                          ? process.env.REACT_APP_STORAGE_URL +
                            prevProduct.images[0].path
                          : placeholder
                      }
                      alt={prevProduct.name}
                      className="prevprod_img"
                      width="50"
                    />
                  ) : (
                    <img src={backward} alt="" className="prevprod_img" />
                  )}
                </div>
              </Link>
              <Link
                to={
                  nextProduct
                    ? location.pathname.includes("search")
                      ? `/search/result/${params.keyword}/${nextProduct.name}/${nextProduct.id}`
                      : `/product/details/${params.category}/${params.gendre}/${params.style}/${nextProduct.name}/${nextProduct.id}`
                    : "#"
                }
                onClick={() => nextProduct && dispatch(nextProd(nextProduct))}
              >
                <div className="arrow_contanier arrow_contanier_right">
                  <img src={forward} alt="" className="arrow_next" />
                  {nextProduct ? (
                    <img
                      src={
                        nextProduct.images.length
                          ? process.env.REACT_APP_STORAGE_URL +
                            nextProduct.images[0].path
                          : placeholder
                      }
                      alt={nextProduct.name}
                      className="nextprod_img"
                      width="50"
                    />
                  ) : (
                    <img src={forward} alt="" className="nextprod_img" />
                  )}
                </div>
              </Link>
            </>
          )}
      </div>*/}
    </div>
  );
};

export default ProductFooter;
